/**
 * Window Helper - Utility functions for window-level operations
 */


/**
 * Initialize window-level listeners
 * Should be called once in AppComponent ngOnInit()
 */
export function initializeWindowListeners(key: string): void {
  // Clear MAPTILER_CACHE_STATUS on page unload/refresh
  window.addEventListener('beforeunload', () => {
    clearSessionStorageItem(key);
  });
}

/**
 * Clear specific session storage item
 */
export function clearSessionStorageItem(key: string): void {
  sessionStorage.removeItem(key);
  console.log(`🗑️ Cleared ${key} from sessionStorage`);
}

/**
 * Clear all session storage
 */
export function clearAllSessionStorage(): void {
  sessionStorage.clear();
  console.log('🗑️ All sessionStorage cleared');
}

/**
 * Clear localStorage while preserving chart layout and deleted-chart preferences.
 * Keys matching chartLayout_* or deletedCharts_* are kept intact.
 */
export function clearLocalStorageExceptCharts(): void {
  const preserve: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.startsWith('chartLayout_') || key.startsWith('deletedCharts_'))) {
      preserve.push(key);
    }
  }
  const saved: Record<string, string> = {};
  preserve.forEach(k => { saved[k] = localStorage.getItem(k) as string; });
  localStorage.clear();
  preserve.forEach(k => localStorage.setItem(k, saved[k]));
}
